export default "__VITE_ASSET__CkKvaKpJ__"